<template>
  <div class="auth-wrapper d-flex no-block justify-content-center align-items-center" style="">
    <div class="auth-box">
      <div id="resetpwd">
        <div class="logo">
          <span class="db">
            <img src="../../assets/images/logo/logo-icon-lg.png" style="width:40px; height:auto;" alt="logo">
            <img src="../../assets/images/logo/logo-text-lg.png" style="width:100px; height:auto;" alt="logo">
          </span>
          <p />
          <h5 class="font-medium m-b-20">
            Welcome back!
          </h5>
          <p />
        </div>
        <!-- Form -->
        <div class="row">
          <div class="col-12">
            <form id="resetpwdform" class="form-horizontal m-t-20" @submit.prevent="resetpwd">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span id="basic-addon1" class="input-group-text"><i class="ti-user" /></span>
                </div>
                <input v-model="password" v-validate="'required'" aria-describedby="basic-addon1" aria-label="Password" class="form-control form-control-lg" placeholder="Password" type="password">
              </div>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span id="basic-addon1" class="input-group-text"><i class="ti-user" /></span>
                </div>
                <input v-model="password1" v-validate="'required'" aria-describedby="basic-addon1" aria-label="Password" class="form-control form-control-lg" placeholder="Password" type="password">
              </div>

              <div class="form-group text-center">
                <div class="col-xs-12 p-b-20">
                  <button class="btn btn-block btn-lg btn-dribbble" type="submit">
                    Set Password
                  </button>
                </div>
              </div>
              <hr>
              <div class="form-group m-b-0 m-t-10">
                <div class="col-sm-12 text-center text-muted">
                  Release {{ this.$parent.version }}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForgotPwd',
  data () {
    return {
      $SITE_URI: this.$SITE_URI,
      loading: false,
      password: '',
      password1: '',
      token: '',
      loggingIn: false,
      error: ''
    }
  },
  mounted () {
    this.init()
    this.$parent.release()
  },
  methods: {
    init () {
      $('[data-toggle="tooltip"]').tooltip()
      $('.preloader').fadeOut()

      $('#to-recover').on('click', function () {
        $('#loginform').slideUp()
        $('#recoverform').fadeIn()
      })
      this.token = this.$route.query.token
      console.log(this.$route.query.token)
    },
    checkCurrentLogin () {
      if (this.currentUser) {
        this.$router.replace(this.$route.query.redirect || '/')
      }
    },
    resetpwd () {
      const self = this
      if (this.password !== this.password1) {
        this.$swal({
          type: 'error',
          title: 'Password did not matched',
          timer: 5000
        })
      }
      this.$validator.validateAll()
        .then(result => {
          if (result) {
            self.loading = true
            this.$accounts.post('/resetPassword', { token: this.token, password: this.password, siteuri: this.$SITE_URI + '/auth/resetpwd' })
              .then(() => this.resetSuccessful())
              .catch(err => this.resetFailed(err))
          }
        })
    },
    resetSuccessful () {
      this.loading = false

      this.$swal({
        type: 'success',
        title: 'Password Reset Successful',
        text: 'Please login using your new Password.',
        timer: 5000
      })
      this.$router.replace('/')
    },
    resetFailed (err) {
      this.loading = false

      console.log(err)

      const data = err.response.data
      if (data.status === 404) {
        this.$swal({
          type: 'error',
          title: 'Profile Not Found',
          text: 'Your email was not found. Please make sure your email was typed correctly.',
          timer: 5000
        })
      } else if (data.status === 412) {
        this.$swal({
          type: 'error',
          title: 'Confirmation Pending',
          text: 'We sent you a confirmation link to your email. Please check your email and follow instructions sent there.',
          timer: 5000
        })
      } else {
        this.$swal({
          type: 'error',
          title: 'Authentication Error',
          text: data.description || data.detail,
          timer: 5000
        })
      }

      this.error = 'Login failed!'
      this.$store.dispatch('logout')
      delete localStorage.token
    }
  }
}
</script>

<style scoped>
.auth-wrapper {
  background: linear-gradient(
      0deg,
      rgba(54, 64, 78, 0.75),
      rgba(54, 64, 78, 0.75)
    ),
    url(../../assets/images/big/harvest.jpg);
  background-size: cover;
}
</style>
